<script>
  import solicitacaoReembolsoTerceiroServico from '../servico';
  import { aplicarFiltrosDaQuery } from '~js/filtros-por-query';
  import projetoServico from '~modulos/projeto/servico';
  import Paginacao from '~componentes/Paginacao.vue';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import Radio from '~componentes/Radio.vue';
  import ModalLiberarCancelar from '~componentes/ModalLiberarCancelar.vue';
  import BotaoReenviarEmail from '~componentes/BotaoReenviarEmail.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import ModalProtocolos from '~componentes/ModalProtocolos.vue';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import DatePicker from 'vue2-datepicker';
  import ModalArquivosLancamento from '~componentes/ModalArquivosLancamento.vue';


  export default {
    components: { Paginacao, Radio, ModalLiberarCancelar, BotaoReenviarEmail, ModalArquivosSolicitacao, ModalArquivosLancamento, ModalProtocolos, DatePicker, ModalMensagem },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        solicitacoes: [],
        carregando: true,
        filtros: this.camposFiltros(),
        projetos: [],
        modalLiberarCancelar: false,
        modalArquivos: false,
        modalProtocolos: false,
        solicitacaoSelecionada: null,
        salvandoLiberacao: false,
        animated: true,
        configuracao: this.$storage.configuracao(),
        modalMensagem: false,
        modalArquivosLancamento: false,
      }
    },
    methods: {
      camposFiltros() {
        return {
          tipo: 1,
          idProjeto: '',
          mostrarSolicitacoes: '0',
          periodo: '',
          codigo: '',
          filtrado: false,
          nome: '',
          documento: '',
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.$nextTick(() => {
          $('#projeto').val(0);
          $('#projeto').trigger('change.select2');
        });

        this.lista();
      },
      filtrar() {
        this.filtros.filtrar = true;
        this.lista();
      },
      lista(pagina = 1) {
        this.carregando = true;

        return solicitacaoReembolsoTerceiroServico.lista(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.solicitacoes = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("SolReembolsoTerceiro")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      mostrarModalLiberarCancelar(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalLiberarCancelar = true;
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      mostrarModalArquivosLancamento(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivosLancamento = true;
      },
      mostrarModalProtocolos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalProtocolos = true;
      },
      liberar() {
        this.salvandoLiberacao = true;

        solicitacaoReembolsoTerceiroServico
          .liberar(this.solicitacaoSelecionada.idSolicitacaoReembolsoTerceiro)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.liberado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoReembolsoTerceiro} liberada com sucesso.`);
            } else {
              toastr.warning(`Você não tem permissão para liberar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
          })
          .then(this.lista);
      },
      cancelar() {
        this.salvandoLiberacao = true;

        solicitacaoReembolsoTerceiroServico
          .cancelar(this.solicitacaoSelecionada.idSolicitacaoReembolsoTerceiro)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.cancelado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoReembolsoTerceiro} cancelada com sucesso.`);
            } else {
              toastr.warning(`Você não tem permissão para cancelar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
          })
          .then(this.lista);
      },
      liberadoOuCancelado(solicitacao) {
        return !!solicitacao.liberacaoCoordenador || !!solicitacao.statusSolicitacao;
      },
      status(solicitacao) {
        if (solicitacao.liberacaoCoordenador && solicitacao.statusSolicitacao === 0) {
          return 'Liberada pelo coordenador';
        } else if (solicitacao.statusSolicitacao === 1) {
          return 'Liberada pela instituição';
        } else if (solicitacao.statusSolicitacao === 2) {
          return 'Cancelada pela instituição';
        } else if (solicitacao.statusSolicitacao === 3 || solicitacao.statusSolicitacao === 4 || solicitacao.statusSolicitacao === 5) {
          return 'Cancelada pelo coordenador';
        } else {
          return 'Aguardando liberação';
        }
      },
      modalLiberarCancelarFechado() {
        this.animated = false;
        this.modalLiberarCancelar = false;
        this.solicitacaoSelecionada = null;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },
      modalArquivosLancamentoFechado() {
        this.animated = false;
        this.modalArquivosLancamento = false;
        this.solicitacaoSelecionada = null;
      },
      modalProtocolosFechado() {
        this.animated = false;
        this.modalProtocolos = false;
        this.solicitacaoSelecionada = null;
      },
      tipo(tipo) {
        if (tipo === 0) {
          return 'Passagem';
        }
        if (tipo === 1) {
          return 'Diária';
        }

        return 'Adiantamento';
      },
      reemviarEmail(id) {
        return solicitacaoReembolsoTerceiroServico.reenviarEmail(id);
      },
      erroReemviarEmail(erro, id) {
        toastr.error(`Erro ao reenviar o e-mail da solicitação nº ${id}`);
      },
      enviadoReemviarEmail(id) {
        toastr.success(`E-mail da solicitação nº ${id} reenviado com sucesso.`);
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
        this.lista(this.pagina);
      },
    },
    created() {
      if (this.$route.params.filtrosBag)
        this.filtros = this.$route.params.filtrosBag;

      aplicarFiltrosDaQuery(this, this.filtros, this.$route.query);
      this.lista(this.pagina);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Reembolso Terceiro - Lista';
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-reembolso-terceiro.nova';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.listaDeProjetos();

      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
        .change(function (e) {
          _this.$set(_this.filtros, 'idProjeto', this.value);
        });

      if (this.$route.params.filtrosBag)
        if (this.filtros.filtrar)
          $('.ibox').removeClass('collapsed');
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>


<style scoped>
  .mensagemNaoLida {
    font-size: 1.20em;
    color: #1d9d74;
    margin-right: 3px;
  }
</style>


<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-liberar-cancelar :mostrar="modalLiberarCancelar"
                            :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoReembolsoTerceiro : ''"
                            :salvando="salvandoLiberacao"
                            :liberando="configuracao.solReembolsoTerceiroMsgConfirmacao ? false : true"
                            :mensagem="configuracao.solReembolsoTerceiroMsgConfirmacao"
                            @fechado="modalLiberarCancelarFechado"
                            @liberar="liberar"
                            @cancelar="cancelar">
    </modal-liberar-cancelar>

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoReembolsoTerceiro : ''"
                                tipo="reembolso-terceiro"
                                :idProtocolo="solicitacaoSelecionada ? solicitacaoSelecionada.idProtocolo : ''"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-arquivos-lancamento :mostrar="modalArquivosLancamento"
                               :id="solicitacaoSelecionada ? solicitacaoSelecionada.idLancamento : ''"
                               @fechado="modalArquivosLancamentoFechado">
    </modal-arquivos-lancamento>

    <modal-protocolos :mostrar="modalProtocolos"
                      :numeroProtocolo="solicitacaoSelecionada ? solicitacaoSelecionada.numeroProtocolo : ''"
                      @fechado="modalProtocolosFechado">
    </modal-protocolos>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoReembolsoTerceiro : ''"
                    tipo="SolReembolsoTerceiro"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <div class="row">
      <div class="col-lg-12">

        <div class="col-xs-12" v-if="this.configuracao.lgpdAvisoSolReembolsoTerceiro">
          <h3 class="text-danger font-bold" v-if="this.configuracao.lgpdAvisoSolReembolsoTerceiro">{{configuracao.lgpdAvisoSolReembolsoTerceiro}}</h3>
        </div>

        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group">
                  <label class="control-label" for="projeto">Projeto</label>

                  <select id="projeto"
                          class="form-control"
                          v-model="filtros.idProjeto">
                    <option value="0">Todos</option>
                    <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="nome">Nome</label>

                  <input type="text"
                         class="form-control"
                         id="nome"
                         v-model="filtros.nome">
                </div>
              </div>

              <div class="col-xs-3">
                <div class="form-group" :class="{'has-error': errors.has('documento')}">
                  <label class="control-label" for="documento">CPF do beneficiário</label>

                  <input type="text"
                         class="form-control"
                         id="documento"
                         v-model="filtros.documento"
                         data-vv-as="cpf"
                         data-vv-name="documento"
                         v-mascara="'cpf'"
                         v-validate="'cpf'">

                  <p class="text-danger" v-show="errors.has('documento')">{{ errors.first('documento') }}</p>
                </div>
              </div>

              <div class="col-xs-5">
                <div class="form-group">
                  <label class="control-label">Período</label>

                  <date-picker v-model="filtros.periodo"
                               input-class="form-control"
                               range
                               :editable="false"
                               lang="pt-br"
                               :confirm="true"
                               range-separator="a"
                               format="DD/MM/YYYY"
                               :shortcuts="false">
                  </date-picker>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="codigo">Código da solicitação</label>

                  <input type="text"
                         class="form-control"
                         id="codigo"
                         v-model="filtros.codigo"
                         v-numero>
                </div>
              </div>
              <div class="col-xs-8">
                <div class="form-group">
                  <label class="control-label block">Mostrar solicitações</label>

                  <radio v-model="filtros.mostrarSolicitacoes"
                         selected-value="0"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Todas
                  </radio>
                  <radio v-model="filtros.mostrarSolicitacoes"
                         selected-value="1"
                         type="success"
                         :inline="true"
                         class="margin-right-10">
                    Aguardando liberação
                  </radio>
                  <radio v-model="filtros.mostrarSolicitacoes"
                         selected-value="2"
                         type="success"
                         :inline="true">
                    Liberadas
                  </radio>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-success no-margins" @click="filtrar">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-eraser"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                  <tr>
                    <th v-if="(!configuracao.naoUtilizarMensageria && !configuracao.desativarMensageriaSolReembolsoTerceiro)">Mensagens</th>
                    <th class="text-center">Número</th>
                    <th>Data solicitação</th>
                    <th>Solicitante</th>
                    <th>Projeto</th>
                    <th>Beneficiário</th>

                    <th>Vencimento</th>
                    <th>Previsão</th>
                    <th>Efetivação</th>

                    <th>Valor(R$)</th>
                    <th v-if="configuracao.criarProtocoloSolicitacao">Protocolo</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(solicitacao, index) in solicitacoes">
                    <td v-if="(!configuracao.naoUtilizarMensageria && !configuracao.desativarMensageriaSolReembolsoTerceiro)">
                      <div v-if="solicitacao.quantidadeNaoLida > 0">
                        <i class="fa fa-info-circle mensagemNaoLida" v-tooltip="'Leitura pendente'"></i> {{solicitacao.quantidadeNaoLida}}
                      </div>
                    </td>
                    <td class="text-center">{{ solicitacao.idSolicitacaoReembolsoTerceiro || '---' }}</td>
                    <td>{{ solicitacao.dataSolicitacao | formatarData }} - {{ solicitacao.dataSolicitacao | formatarHora }}</td>
                    <td>{{ solicitacao.solicitante || '---' }}</td>
                    <td>{{ solicitacao.nomeProjeto || '---' }}</td>
                    <td>{{ solicitacao.nome || '---' }}</td>

                    <td>{{ solicitacao.dataVencimento | formatarData('---') }}</td>
                    <td>{{ solicitacao.dataPrevisao | formatarData('---') }}</td>
                    <td>{{ solicitacao.dataLancamento | formatarData('---') }}</td>

                    <td>{{ solicitacao.valor | formatarNumero }}</td>
                    <td v-if="configuracao.criarProtocoloSolicitacao">
                      <a @click.prevent="mostrarModalProtocolos(solicitacao)" v-if="solicitacao.numeroProtocolo">{{ solicitacao.numeroProtocolo }} <i class="fa fa-external-link"></i></a>
                      <span v-if="!solicitacao.numeroProtocolo">---</span>
                    </td>
                    <td>{{ status(solicitacao) }}</td>
                    <td>
                      <router-link class="btn btn-primary btn-xs"
                                   active-class=""
                                   v-tooltip="'Relatório'"
                                   :to="{ name: 'solicitacao-reembolso-terceiro.relatorio', params: { id: solicitacao.idSolicitacaoReembolsoTerceiro , filtrosBag: filtros } }">
                        <i class="fa fa-file-text-o"></i>
                      </router-link>

                      <router-link tag="button"
                                   :disabled="liberadoOuCancelado(solicitacao)"
                                   class="btn btn-secondary btn-xs"
                                   active-class=""
                                   v-tooltip="'Editar'"
                                   :to="{ name: 'solicitacao-reembolso-terceiro.editar', params: { id: solicitacao.idSolicitacaoReembolsoTerceiro, idCript:  solicitacao.idSolicitacao } }">
                        <i class="fa fa-pencil"></i>
                      </router-link>

                      <button :disabled="liberadoOuCancelado(solicitacao)"
                              class="btn btn-warning btn-xs"
                              v-tooltip="'Liberar ou Cancelar solicitação'"
                              @click="mostrarModalLiberarCancelar(solicitacao)">
                        <i class="fa fa-check"></i>
                      </button>

                      <button type="button"
                              class="btn btn-info btn-xs"
                              v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                              @click="mostrarModalArquivos(solicitacao)"
                              v-if="configuracao.usarArquivosSolicitacaoReembolsoTerceiro">
                        <i class="fa fa-archive"></i>
                      </button>

                      <button type="button"
                              class="btn btn-light btn-xs"
                              v-tooltip="'Listar arquivos financeiro'"
                              @click="mostrarModalArquivosLancamento(solicitacao)"
                              v-if="configuracao.usarArquivosContasAPagar && configuracao.visualizarArquivosLancamento">
                        <i class="fa fa-archive"></i>
                      </button>

                      <button type="button"
                              class="btn btn-success btn-xs"
                              v-tooltip="'Ler\Enviar mensagem'"
                              @click="mostrarModalMensagem(solicitacao)"
                              v-if="(!configuracao.naoUtilizarMensageria && !configuracao.desativarMensageriaSolReembolsoTerceiro)">
                        <i class="fa fa-comment"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-show="carregando">
                    <td colspan="13">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-reembolso-terceiro/componentes/SolicitacaoReembolsoTerceiroLista.vue